import axios from "axios";
// import Cookies from 'js-cookie';
import { reactLocalStorage } from 'reactjs-localstorage';
import { OktaAuth } from '@okta/okta-auth-js';

const unsecurePaths = ['users/login', 'users/verifycode?langKey=en'];

// const endpoint = "https://doppler-dev-services.gemflowstation.com/api/";
const endpoint = process.env.REACT_APP_BASE_API_URL;
const API = axios.create({
    baseURL: endpoint,
    headers: { "Access-Control-Allow-Origin": "*" },
    responseType: "json"
});

API.interceptors.request.use(function (config) {
    if (!navigator.onLine) { 
        throw new Error("Something went wrong"); 
    }
    if (unsecurePaths.includes(config.url)) {
        return config;
    }

    let token = JSON.parse(reactLocalStorage.get('okta-token-storage'))
    const accessToken = token.accessToken.accessToken
    // const accessToken = localStorage.getItem('accessToken');
    config.headers.Authorization = accessToken ? `Bearer ${accessToken}` : null;
    return config;
});

API.interceptors.response.use(async (response) => {
    return response;
}, async (error) => {
    if (error && error.response) {
        const { config, response: { status } } = error;
        const originalRequest = config;
        if (status === 403 && !originalRequest._retry) {
            originalRequest._retry = true;
            oktaAuth.signOut('/')
            window.location.reload();
            return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    }else {
        return Promise.reject(error);
    }
});

const oktaAuth = new OktaAuth({
    issuer: process.env.REACT_APP_OKTA_DOMAIN,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID
  });

export default API;